import { VideoSrc } from './video';
// API の DefaultCountLessonCoachID と同じ。コーチマスタは 1:男性 / 2:女性
export const DEFAULT_COUNT_LESSON_COACH_ID = 2;
export class CountLessonCoach {
    constructor(data, config) {
        Object.defineProperty(this, "id", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "baseAnimationSrc", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "baseImageSrc", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "isSelected", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.id = data.id;
        this.name = data.name;
        this.baseAnimationSrc = '';
        if (data.baseAnimationSrc) {
            // 登録済みのHLSパスは維持し、MP4/MOVは通常レッスンと同じURL変換を使う。
            this.baseAnimationSrc = /\.m3u8(?:[?#]|$)/i.test(data.baseAnimationSrc)
                ? config.cdnBaseForMovie + data.baseAnimationSrc
                : new VideoSrc(data.baseAnimationSrc, config).hlsURL;
        }
        this.baseImageSrc = data.baseImageSrc ? config.cdnBaseURL + data.baseImageSrc : '';
        this.isSelected = data.isSelected;
    }
}
